import { SchemaDefinition } from "../validator/schema-definition-interface";

/**
 * The schema definition for the stored service action object.
 */
export const storedServiceActionSchema: SchemaDefinition = {
	Name: 'stored-service-action',
	Properties: {
		ActionType: { Type: 'number' },
		Required: { Type: 'boolean' },
		CompletedDate: { Type: 'Date' },
	}
}